var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('header', {
    staticClass: "sanity-header absolute pointer-events-none",
    class: [!_vm.backdrop && 'bg-none', !_vm.showMarquee && 'no-marquee']
  }, [_vm.showMarquee ? _c('TextMarquee', {
    attrs: {
      "marquee-text": _vm.marqueeText
    }
  }) : _vm._e(), _vm._v(" "), _c('Container', [_c('div', {
    staticClass: "content"
  }, [_vm.showLogo ? [_c('a', {
    staticClass: "pointer-events-auto",
    attrs: {
      "href": "/"
    }
  }, [_vm.showBlackLogo ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/extra-logo-black.svg"),
      "alt": "Extra logo"
    }
  }) : _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/extra-logo-white.svg"),
      "alt": "Extra logo"
    }
  })])] : _vm._e(), _vm._v(" "), _vm.showPartnershipLogo ? _c('img', {
    staticClass: "partnershipLogo self-end",
    attrs: {
      "src": _vm.partnershipLogo,
      "alt": "Extra partnership logo"
    }
  }) : _vm._e()], 2)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };